import React, { createRef, Fragment, useState } from "react";
import { CommmonService } from "app/_services/CommonService/CommonService";
import moment from "moment";
import AddUserRegistration from "./AddUserRegistration";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { BsFillInfoCircleFill } from "react-icons/bs";
import {
  FaRegTrashAlt,
  FaCheck,
  FaTimes,
  FaToggleOn,
  FaToggleOff,
  FaEnvelope,
  FaMobile,
} from "react-icons/fa";
import { FiPlusCircle, FiSettings, FiEdit3, FiEye } from "react-icons/fi";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert"; // Import
import toastr from "toastr";

import {
  USER_PERMISSION,
  checkUserLevelAccess,
  userTableColumn,
  userFilterFields,
  USER_STATUS_OBJ,
} from "./helper";

import { UserService } from "app/_services/UserService/UserService";
import { capitalizeName, formatDDMMYYYYbyYYYYMMDD } from "app/_helpers/helper";
import {
  isPermissions,
  SetGlobalPermission,
} from "app/Components/SetPermission/Permissions";
import { SetPermission } from "app/Components/SetPermission/Permissions";

import { getAllSites } from "app/_services/ehs/ehsSiteServices";

import LastLog from "app/views/custom/components/Logs/LastLog";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import UserSiteModal from "app/Components/_userManagement/UserSiteModal/UserSiteModal";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";
import EmployeeFilters from "../Employee/Component/EmployeeFilters";
import UserFilters from "./UserFilters";
import { validateRowFilter } from "app/_pages/_healthSafetyEnvironment/IncidentManagement/CONSTANTS";
import { AiOutlineLogout } from "react-icons/ai";
import { forceLogOut } from "app/_services/ehs/ehsBlockIp";
import userData from "app/redux/reducers/userData.reducer";
import ScrollBar from "react-perfect-scrollbar";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import { DDMMYYYYFormat, DDMMYYYYHHMMAFormat } from "app/_helpers/dateHelper";
import { SelectAllHeader } from "app/_pages/_healthSafetyEnvironment/TrainingManagement/Assign/Assign";
import { siteTypeObj } from "app/_pages/_globalConfiguration/HealthSafetyEnvironment/Sites/Sites";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";

class UserRegistration extends React.Component {
  constructor(props) {
    super(props);
    this.tableContainerRef = createRef(null);
    this.selectAllRef = createRef(false);
    this.selectAllRef.current = false;

    this.state = {
      loading: true,
      superadmin: "",
      userid: "",
      rowUserId: "",
      initialUserData: [],
      userData: [],

      show: false,
      title: "",
      description: "",

      selectedUser: null,
      showSiteModal: false,
      showViewModal: false,
      showEditModal: false,
      showAddModal: false,
      showFilter: false,
      modalData: {},

      siteList: [],
      filter: {
        siteIdEmp: "",
        locationType: "",
        userStatus: "",
        roleId: "",
        imRole: "",
        vflRole: "",
        trainingRole: "",
        medicalRole: "",
        ohseRole: "",
        formARole: "",
        departmentName: "",
        contactNumber: "",
        email: "",
        employeeId: "",
      },
      selectRow: {},
      selectedRowUsers: [],
      sort: { order: "asc", dataField: "" },
    };
  }
  onReset = () => {
    this.setState(
      (prev) => ({
        ...prev,
        filter: {
          siteIdEmp: "",
          locationType: "",
          userStatus: "",
          roleId: "",
          imRole: "",
          vflRole: "",
          trainingRole: "",
          medicalRole: "",
          ohseRole: "",
          formARole: "",
          departmentName: "",
          contactNumber: "",
          email: "",
          employeeId: "",
        },
      }),
      () => this.onChangeFilter()
    );
  };

  componentDidMount() {
    this.setUserData();
    this.getAllSiteList();
    this.loggedUser();
    this.handleCloseViewModal();
    this.selectRowFun();
  }
  setUserData = async () => {
    let response = await UserService.getUsers();

    if (!response?.status || !Array.isArray(response?.data)) {
      this.setState({
        loading: false,
      });
      return this.setState({
        userData: [],
      });
    }
    const responseData = response.data.map((row, rowIndex) => {
      row["sid"] = rowIndex + 1;
      row["viewCreatedAt"] = formatDDMMYYYYbyYYYYMMDD(row.createdAt);
      row["name"] = `${capitalizeName(
        (row.firstName ?? "") + " " + (row.lastName ?? "")
      )}`;
      row["departmentName"] = row?.department?.name;
      row["employeeid"] = row?.employeeid;
      row["locationType"] = row?.employee?.ehsSite?.siteType;
      row["userStatus"] = row?.activeStatus
        ? USER_STATUS_OBJ.active
        : USER_STATUS_OBJ.inActive;
      row["desktopLoginVerifiedAt"] = DDMMYYYYHHMMAFormat(row.desktopLoginVerifiedAt);
      row["siteLocationName"] = row?.employee
        ? row?.employee?.ehsSite?.name
        : row?.ehsSite?.name;
      // row["locationType"] = siteTypeObj[row?.locationType];
      row["createdAt"] = row?.createdAt ? DDMMYYYYFormat(row?.createdAt) : row?.createdAt;
      row["lastResentUserMailDate"] = row?.lastResentUserMailDate
        ? DDMMYYYYHHMMAFormat(row?.lastResentUserMailDate)
        : row?.lastResentUserMailDate;
      return row;
    });

    this.setState({
      userData: responseData,
      initialUserData: responseData,
    });
    this.setState({
      loading: false,
    });
  };
  onSortSelection = (sort) => {
    this.setState((prev) => {
      const newRows = [...prev.userData].sort((a, b) => {
        if (prev.selectedRowUsers.includes(sort.order === "asc" ? a.id : b.id)) return -1;
        return 1;
      });
      return {
        ...prev,
        sort: {
          order: sort.order,
          dataField: "_selection",
        },
        userData: newRows,
      };
    });
  };

  handleOnSelectAll = (isSelect) => {
    if (isSelect) {
      this.setState((prev) => ({
        ...prev,
        selectedRowUsers: prev.userData.map((r) => r.id),
      }));
      this.selectRowFun();
    } else {
      this.setState((prev) => ({
        ...prev,
        selectedRowUsers: [],
      }));
      this.selectRowFun();
    }
  };

  handleOnSelect = (row, isSelect) => {
    this.selectAllRef.current = false;
    if (isSelect) {
      this.setState((prev) => ({
        ...prev,
        selectedRowUsers: [...prev.selectedRowUsers, row.id],
      }));
      this.selectRowFun();
    } else {
      this.setState((prev) => ({
        ...prev,
        selectedRowUsers: prev.selectedRowUsers.filter((x) => x !== row.id),
      }));
      this.selectRowFun();
    }
  };

  selectRowFun = () => {
    this.setState((prev) => ({
      ...prev,
      selectRow: {
        mode: "checkbox",
        clickToSelect: true,
        hideSelectAll: true,
        selected: prev.selectedRowUsers,
        onSelect: this.handleOnSelect,
        // selectionHeaderRenderer: selectionHeaderRenderer,
      },
    }));
  };

  sendMailForMultiUser = () => {
    confirmAlert({
      title: "Send Email",
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            const obj = { userIdList: this.state.selectedRowUsers };
            const response = await UserService.sendEmailToUser(obj);
            if (!response?.data?.status) return;
            toastr.success(response?.data?.message);
            this.setState((prev) => ({
              ...prev,
              selectedRowUsers: [],
            }));
            this.selectRowFun();
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  sendMailButton = () => {
    if (this.state.selectedRowUsers?.length)
      return (
        <Button
          onClick={this.sendMailForMultiUser}
          style={{ marginRight: 20, paddingBottom: "2px" }}
        >
          Send Email
        </Button>
      );
  };

  async loggedUser() {
    let response = await UserService.loggedUser();
    if (response && response.status) {
      this.setState({
        userid: response?.data?.id,
      });
    }
    this.checkuser(this.state.userData);
  }
  async checkuser(data) {
    if (this.state.userData != "") {
      const response = await CommmonService.userCheck(data);
      //   if (!response?.status) return toastr.error(response?.message);
      // console.log("response", response);
      this.setState({
        superadmin: response,
      });
      // console.log(this.state.superadmin);
    }
  }
  handleClose = () => {
    this.setState((prev) => ({
      ...prev,
      show: false,
    }));
  };
  handleShow = (title, description) => {
    const des = description.replace(/\n/g, "<br />");

    this.setState((prev) => ({
      ...prev,
      title: title,
      description: des,
      show: !prev.show,
    }));
  };

  isDescriptionNotBlank = (description) => {
    if (description == null || description == "") {
      return false;
    } else {
      return true;
    }
  };

  /************** Api Call *************/
  getAllSiteList = async () => {
    let response = await getAllSites("filter[status]=1&filter[activeStatus]=active");
    if (!response?.data || !response?.status) return;

    // setSiteList(response.data);
    this.setState((prev) => ({ ...prev, siteList: response.data }));
  };

  setClientData = async () => {
    let response = await UserService.getClientdata();
    console.log("getClientdata");
    if (!response?.status || !Array.isArray(response?.data))
      return this.setState({
        userData: [],
      });

    const responseData = response.data.map((row, rowIndex) => {
      row["sid"] = rowIndex + 1;
      row["viewCreatedAt"] = formatDDMMYYYYbyYYYYMMDD(row.createdAt);
      row["name"] = `${capitalizeName(
        (row.firstName ?? "") + " " + (row.lastName ?? "")
      )}`;
      row["departmentName"] = row?.department?.name;
      row["locationType"] = row?.employee
        ? row?.employee?.ehsSite?.siteType
        : row?.ehsSite?.siteType;
      row["siteLocationName"] = row?.employee
        ? row?.employee?.ehsSite?.name
        : row?.ehsSite?.name;
      row["userStatus"] = row?.activeStatus
        ? USER_STATUS_OBJ.active
        : USER_STATUS_OBJ.inActive;
      return row;
    });

    this.setState({
      userData: responseData,
      initialUserData: responseData,
    });
  };
  setIedData = async () => {
    // console.log("getIeddata");
    let response = await UserService.getIeddata();

    if (!response?.status || !Array.isArray(response?.data))
      return this.setState({
        userData: [],
      });

    const responseData = response.data.map((row, rowIndex) => {
      row["sid"] = rowIndex + 1;
      row["viewCreatedAt"] = formatDDMMYYYYbyYYYYMMDD(row.createdAt);
      row["name"] = `${capitalizeName(
        (row.firstName ?? "") + " " + (row.lastName ?? "")
      )}`;
      row["departmentName"] = row?.department?.name;
      row["locationType"] = row?.employee?.ehsSite?.siteType;
      row["userStatus"] = row?.activeStatus
        ? USER_STATUS_OBJ.active
        : USER_STATUS_OBJ.inActive;

      return row;
    });

    this.setState({
      userData: responseData,
      initialUserData: responseData,
    });
  };
  alldata = () => {
    this.setUserData();
    // console.log("alldata");
  };
  clientdata = () => {
    // this.setClientData();
    const previousdata = JSON.parse(JSON.stringify(this.state.initialUserData));
    const data = previousdata.filter((previousdata) => {
      return previousdata.role.siteType != null;
    });
    console.log(data);
    this.setState((prev) => ({
      ...prev,
      userData: data,
    }));
  };
  Ieddata = () => {
    // this.setIedData();
    // console.log("Ieddata");
    const previousdata = JSON.parse(JSON.stringify(this.state.initialUserData));
    const data = previousdata.filter((previousdata) => {
      return previousdata.role.siteType == null;
    });
    console.log(data);
    this.setState((prev) => ({
      ...prev,
      userData: data,
    }));
  };
  /************** Normal Call *************/
  delete = (id) => {
    confirmAlert({
      title: "Delete User",
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            let response = await UserService.deleteUser(id);
            if (response) {
              if (response.status) {
                toastr.info(response.message || "Deleted Successfully!");
                this.setUserData();
              } else if (response.message) {
                toastr.info(response.message);
              }
            }
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  activeInactive(e, id, status) {
    e.preventDefault();
    confirmAlert({
      title: status === 0 ? "Activate User" : "De-Activate User",
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            let data = {
              activeStatus: status === 0 ? 1 : 0,
            };
            let response = await UserService.activeUser(id, data);

            if (response && response.status) {
              this.setUserData();
            }
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  }

  ApproveAndUnApprove(e, id, status, row) {
    e.preventDefault();
    if (
      row.department === "" ||
      row.department === null ||
      row.department === undefined
    ) {
      toastr.warning("Department did not Find");
    }
    if (row.role === "" || row.role === null || row.role === undefined) {
      toastr.warning("Role did not Find");
    }
    confirmAlert({
      title: status === 0 ? "Approve User" : "UnApprove User",
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            let data = {
              approveStatus: status === 0 ? 1 : 0,
            };
            let response = await UserService.approveUser(id, data);
            if (response && response.status) {
              this.setUserData();
            }
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  }
  sendEmailForUser(e, id, status, row) {
    e.preventDefault();
    // if (
    //   row.department === "" ||
    //   row.department === null ||
    //   row.department === undefined
    // ) {
    //   toastr.warning("Department did not Find");
    // }
    // if (row.role === "" || row.role === null || row.role === undefined) {
    //   toastr.warning("Role did not Find");
    // }
    confirmAlert({
      title: status === 0 ? "Email Sent" : "Send Email",
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            const obj = { userIdList: [id] };
            let data = {
              approveStatus: status === 0 ? 1 : 0,
            };
            let response = await UserService.sendEmailToUser(obj);

            if (response && response?.status) {
              toastr.success("Email sent successfully");
              this.setUserData();
            }
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  }
  enableMobileForUser(e, id, status, row) {
    e.preventDefault();
    // if (
    //   row.department === "" ||
    //   row.department === null ||
    //   row.department === undefined
    // ) {
    //   toastr.warning("Department did not Find");
    // }
    // if (row.role === "" || row.role === null || row.role === undefined) {
    //   toastr.warning("Role did not Find");
    // }
    confirmAlert({
      title: status === 0 ? "Enable Mobile" : "Mobile disabled",
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            let data = {
              mobileEnabled: status === 0 ? 1 : 0,
            };
            let response = await UserService.enableMobileToUser(id, data);
            if (response && response.status) {
              this.setUserData();
            }
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  }
  forceLogOutFuntion = async (row) => {
    let response = await forceLogOut({ id: row.id });
    if (response.status) {
      document.getElementById(row.id).className = "icons";
      document.getElementById(row.id).style.pointerEvents = "none";
      return toastr.success(response.message);
    }
  };
  onClickRow = (row) => {
    this.setState((prev) => ({
      ...prev,
      selectedUser: row,
      showSiteModal: true,
    }));
  };

  handleCloseSiteModal = () => {
    this.setState((prev) => ({
      ...prev,
      selectedUser: null,
      showSiteModal: false,
    }));
  };
  handleViewModal = (row) => {
    if (row)
      this.setState((prev) => ({
        ...prev,
        // selectedUser: null,
        showViewModal: true,
        modalData: row,
      }));
  };

  handleCloseViewModal = () => {
    this.setState((prev) => ({
      ...prev,
      // selectedUser: null,
      showViewModal: false,
    }));
  };
  handleEditModal = (id) => {
    this.setState((prev) => ({
      ...prev,
      // selectedUser: null,
      showEditModal: true,
      rowUserId: id,
    }));
  };

  handleCloseEditModal = () => {
    this.setState((prev) => ({
      ...prev,
      // selectedUser: null,
      showEditModal: false,
    }));
  };

  handleAddModal = (id) => {
    this.setState((prev) => ({
      ...prev,
      // selectedUser: null,
      showAddModal: true,
    }));
  };

  handleCloseAddModal = () => {
    this.setState((prev) => ({
      ...prev,
      // selectedUser: null,
      showAddModal: false,
    }));
  };

  setShowFilter = () => {
    this.setState((prev) => ({
      ...prev,
      showFilter: !prev.showFilter,
    }));
  };

  tableToolbarView = () => (
    <>
      {/* <SetPermission
        permission={USER_PERMISSION.ADD}
        data={
          <CustomTooltip tooltip={"Add User"}>
            <Link
              className="icons btn-icon font-20 text-cyanBlue"
              to="/user-management/user-registration/add"
            >
              <FiPlusCircle />
            </Link>
          </CustomTooltip>
        }
      /> */}
      <SetPermission
        permission={USER_PERMISSION.ADD}
        data={
          <CustomTooltip tooltip={"Add User"}>
            <span
              onClick={() => {
                this.handleAddModal();
              }}
              className="icons btn-icon font-20 text-cyanBlue"
            >
              <FiPlusCircle />
            </span>
          </CustomTooltip>
        }
      />
    </>
  );

  tableToolbarBeforeView = () =>
    this.state.showFilter && (
      <UserFilters
        fields={userFilterFields}
        // setForm={setFilterForm}
        form={this.state.filter}
        onChange={this.onChange}
        onReset={this.onReset}
      />
    );

  // <div className="selectDiv">
  //   <SimpleSelect
  //     name="siteId"     import Button from 'react-bootstrap/Button';

  //     className="form-control"
  //     value={this.state.filter.siteId}
  //     onChange={this.onChange}
  //     id="id"
  //     label="name"
  //     options={this.state.siteList}
  //     init="Select"
  //   ></SimpleSelect>
  // </div>

  onChange = ({ target: { name, value, type, checked } }) => {
    this.setState(
      (prev) => ({
        ...prev,
        filter: {
          ...prev.filter,
          [name]: type === "checkbox" ? checked : value,
        },
      }),
      () => this.onChangeFilter()
    );
  };

  onChangeFilter = () => {
    let data = JSON.parse(JSON.stringify(this.state.initialUserData));

    console.log("checkkkk++++", this.state.filter, data);
    data = data?.filter?.((data) => {
      let flag = true;

      if (this.state.filter?.imRole) {
        console.log("/*/*/*/*this.state.filter2", this.state.filter?.imRole);
        const roleObj = data?.accessPermissions?.find(
          (d) =>
            +d.permissionValue &&
            d.permission?.toLowerCase() === this.state.filter?.imRole?.toLowerCase()
        );

        if (!roleObj) flag = false;
        // console.log("/*/*/*/*this.state.filter2", flag);
      }

      if (this.state.filter?.vflRole) {
        const roleObj = data?.accessPermissions?.find(
          (d) =>
            +d.permissionValue &&
            d.permission?.toLowerCase() === this.state.filter?.vflRole?.toLowerCase()
        );
        if (!roleObj) flag = false;
      }

      if (this.state.filter?.trainingRole) {
        const roleObj = data?.accessPermissions?.find(
          (d) =>
            +d.permissionValue &&
            d.permission?.toLowerCase() === this.state.filter?.trainingRole?.toLowerCase()
        );
        if (!roleObj) flag = false;
      }

      if (this.state.filter?.medicalRole) {
        const roleObj = data?.accessPermissions?.find(
          (d) =>
            +d.permissionValue &&
            d.permission?.toLowerCase() === this.state.filter?.medicalRole?.toLowerCase()
        );
        if (!roleObj) flag = false;
      }

      if (this.state.filter?.ohseRole) {
        const roleObj = data?.accessPermissions?.find(
          (d) =>
            +d.permissionValue &&
            d.permission?.toLowerCase() === this.state.filter?.ohseRole?.toLowerCase()
        );
        if (!roleObj) flag = false;
      }

      if (this.state.filter?.formARole) {
        const roleObj = data?.accessPermissions?.find(
          (d) =>
            +d.permissionValue &&
            d.permission?.toLowerCase() === this.state.filter?.formARole?.toLowerCase()
        );
        if (!roleObj) flag = false;
      }

      if (this.state.filter?.siteIdEmp) {
        const siteObj = data?.employee?.ehsSite?.id === this.state.filter?.siteIdEmp;
        if (!siteObj) flag = false;
      }

      if (flag) {
        for (const key in this.state.filter) {
          if (
            !this.state.filter[key] ||
            key === "imRole" ||
            key === "vflRole" ||
            key === "trainingRole" ||
            key === "medicalRole" ||
            key === "ohseRole" ||
            key === "formARole" ||
            key === "siteIdEmp"
          )
            continue;
          if (
            key !== "contactNumber" &&
            key !== "email" &&
            data[key] !== this.state.filter[key]
          )
            return (flag = false);
          else if (
            (key === "contactNumber" || key === "email") &&
            !data[key]?.toLowerCase()?.includes(this.state.filter[key]?.toLowerCase())
          )
            return (flag = false);
        }

        return (flag = true);
      }

      if (flag) flag = validateRowFilter(this.state.filter, data);
      return flag;
    });

    console.log("/*/*/*/*/data", data);
    this.setState((prev) => ({
      ...prev,
      userData: data,
    }));
  };

  render() {
    const { userData, modalData } = this.state;

    const sortableColumn = [
      ...userTableColumn,

      {
        dataField: "role.title",
        text: "Role",
        sort: true,
        formatter: (rowContent, row) => {
          // console.log("row-user /*/*/****/ ", row);
          return (
            <div>
              {row?.role?.title}{" "}
              {this.isDescriptionNotBlank(row?.role?.description) && (
                <>
                  <span
                    title="description"
                    variant="primary"
                    onClick={() =>
                      this.handleShow(row?.role?.title, row?.role?.description)
                    }
                  >
                    <BsFillInfoCircleFill />
                  </span>
                </>
              )}
            </div>
          );
        },
      },
      {
        dataField: "desktopLoginVerifiedAt",
        text: "Last Log In",
        sort: true,
        // formatter: (rowContent, row) => {
        //   // console.log("row-user /*/*/****/ ", row);
        //   return row?.desktopLoginVerifiedAt
        //     ? DDMMYYYYHHMMAFormat(row.desktopLoginVerifiedAt)
        //     : "";
        // },
      },

      {
        dataField: "status",
        text: "Action",
        formatter: (rowContent, row) => {
          const flag = checkUserLevelAccess(row);
          return (
            <div className="actionIconsGroup">
              <SetGlobalPermission
                permission={["superAdmin", "globalAdmin", "projectAdmin"]}
                data={
                  <CustomTooltip tooltip={"View"}>
                    <span
                      onClick={() => {
                        this.handleViewModal(row);
                      }}
                      className="icons text-cyanBlue"
                    >
                      <FiEye />
                    </span>
                  </CustomTooltip>
                }
              />

              {+row?.activeStatus === 1 && flag && (
                <Fragment>
                  {/* <SetGlobalPermission
                    permission={["superAdmin"]}
                    data={
                      <CustomTooltip tooltip={"Edit"}>
                        <Link
                          to={"/user-management/user-registration/edit/" + row.id}
                          className="icons text-cyanBlue"
                        >
                          <FiEdit3 />
                        </Link>
                      </CustomTooltip>
                    }
                  /> */}
                  <SetGlobalPermission
                    permission={["superAdmin"]}
                    data={
                      <CustomTooltip tooltip={"Edit"}>
                        <span
                          onClick={() => {
                            this.handleEditModal(row.id);
                          }}
                          className="icons text-cyanBlue"
                        >
                          <FiEdit3 />
                        </span>
                      </CustomTooltip>
                    }
                  />

                  {row?.employee && (
                    <SetGlobalPermission
                      permission={["superAdmin", "globalAdmin", "projectAdmin"]}
                      data={
                        <CustomTooltip tooltip="Manage Permission">
                          <span
                            onClick={() => this.onClickRow(row)}
                            className="icons text-cyanBlue"
                          >
                            <FiSettings />
                          </span>
                        </CustomTooltip>
                      }
                    />
                  )}
                  {+row.status === 1 ? (
                    <SetGlobalPermission
                      permission={["superAdmin"]}
                      data={
                        <SetGlobalPermission
                          permission="global_userMgmt_delete"
                          data={
                            <CustomTooltip tooltip={"Delete"}>
                              <span
                                onClick={(e) => this.delete(row.id)}
                                href="#"
                                className="icons text-danger pointer"
                              >
                                <FaRegTrashAlt />
                              </span>
                            </CustomTooltip>
                          }
                        />
                      }
                    />
                  ) : (
                    <SetGlobalPermission
                      permission={["superAdmin"]}
                      data={
                        <CustomTooltip tooltip={"Delete"}>
                          <span
                            onClick={(e) => this.delete(row.id)}
                            href="#"
                            className="icons text-danger pointer"
                          >
                            <FaRegTrashAlt />
                          </span>
                        </CustomTooltip>
                      }
                    />
                  )}

                  {/* {row.approveStatus === 0 ? (
                    <SetGlobalPermission
                      permission={["superAdmin", "globalAdmin"]}
                      data={
                        <CustomTooltip tooltip={"Approve Pending"}>
                          <span
                            href="#"
                            className="icons text-danger pointer"
                            onClick={(e) =>
                              this.ApproveAndUnApprove(e, row.id, row.approveStatus, row)
                            }
                          >
                            <FaTimes />
                          </span>
                        </CustomTooltip>
                      }
                    />
                  ) : (
                    <SetGlobalPermission
                      permission={["superAdmin", "globalAdmin"]}
                      data={
                        <CustomTooltip tooltip={"Approved"}>
                          <span
                            href="#"
                            className="icons text-success"
                            onClick={(e) =>
                              this.ApproveAndUnApprove(e, row.id, row.approveStatus, row)
                            }
                          >
                            <FaCheck />
                          </span>
                        </CustomTooltip>
                      }
                    />
                  )} */}

                  {moment().diff(moment(row?.lastResentUserMailDate), "minutes") < 10 ? (
                    <SetGlobalPermission
                      permission={["superAdmin", "globalAdmin"]}
                      data={
                        <CustomTooltip tooltip={"Send Email"}>
                          <span
                            className="btnGrey"
                            // onClick={(e) =>
                            //   this.sendEmailForUser(e, row.id, row.emailSend, row)
                            // }
                          >
                            <FaEnvelope />
                          </span>
                        </CustomTooltip>
                      }
                    />
                  ) : (
                    <SetGlobalPermission
                      permission={["superAdmin", "globalAdmin"]}
                      data={
                        <CustomTooltip tooltip={"Send Email"}>
                          <span
                            className="icons text-primary pointer"
                            onClick={(e) =>
                              this.sendEmailForUser(e, row.id, row.emailSend, row)
                            }
                          >
                            <FaEnvelope />
                          </span>
                        </CustomTooltip>
                      }
                    />
                  )}

                  {row.mobileEnabled === 1 ? (
                    <SetGlobalPermission
                      permission={["superAdmin", "globalAdmin"]}
                      data={
                        <CustomTooltip tooltip={"Disable Mobile"}>
                          <span
                            className="icons text-success pointer"
                            onClick={(e) =>
                              this.enableMobileForUser(e, row.id, row.mobileEnabled, row)
                            }
                          >
                            <FaMobile />
                          </span>
                        </CustomTooltip>
                      }
                    />
                  ) : (
                    <SetGlobalPermission
                      permission={["superAdmin", "globalAdmin"]}
                      data={
                        <CustomTooltip tooltip={"Enable Mobile"}>
                          <span
                            className="icons text-dark pointer"
                            onClick={(e) =>
                              this.enableMobileForUser(e, row.id, row.mobileEnabled, row)
                            }
                          >
                            <FaMobile />
                          </span>
                        </CustomTooltip>
                      }
                    />
                  )}
                </Fragment>
              )}
              {flag ? (
                +row.activeStatus === 1 ? (
                  <SetGlobalPermission
                    permission={["superAdmin", "globalAdmin"]}
                    data={
                      <CustomTooltip tooltip={"Activated"}>
                        <span
                          href="#"
                          className="icons text-success pointer"
                          onClick={(e) =>
                            this.activeInactive(e, row.id, row.activeStatus)
                          }
                        >
                          <FaToggleOn size="20" />
                        </span>
                      </CustomTooltip>
                    }
                  />
                ) : !row?.employee ||
                  (row?.employee && row?.employee?.employmentStatus === "active") ? (
                  <SetGlobalPermission
                    permission={["superAdmin", "globalAdmin"]}
                    data={
                      <CustomTooltip tooltip={"Activation Pending"}>
                        <span
                          href="#"
                          className="icons text-danger pointer"
                          onClick={(e) =>
                            this.activeInactive(e, row.id, row.activeStatus)
                          }
                        >
                          <FaToggleOff size="20" />
                        </span>
                      </CustomTooltip>
                    }
                  />
                ) : (
                  ""
                )
              ) : (
                ""
              )}

              <SetGlobalPermission
                permission={["superAdmin"]}
                data={
                  <SetGlobalPermission
                    permission="global_userMgmt_delete"
                    data={
                      <CustomTooltip tooltip={"Force Logout"}>
                        <span
                          onClick={() => {
                            this.forceLogOutFuntion(row);
                            // forceLogOutFuntion(row);
                          }}
                          href="#"
                          className="icons text-danger pointer"
                          id={row.id}
                        >
                          {/* <FaRegTrashAlt /> */}
                          <AiOutlineLogout />
                        </span>
                      </CustomTooltip>
                    }
                  />
                }
              />
            </div>
          );
        },
      },
    ];

    return (
      <div>
        <MainBreadcrumb
          routeSegments={[
            { name: "User Management", path: "#" },
            { name: "Users", path: "#" },
          ]}
          breadCrumbsText="User_Management_User_Registration"
        />
        <div className="card p-4 mb-4 overflow-visible" ref={this.tableContainerRef}>
          <div className="simple-card-title">
            <h3 className="text-capitalize mb-1">Users</h3>
            <FilterBtn setShowFilter={this.setShowFilter} />
            {/* <BackBtn url="/health-safety-and-environment/training-management" /> */}
          </div>
          {/* <UserFilters
            fields={userFilterFields2}
            // setForm={setFilterForm}
            form={this.state.filter}
            onChange={this.onChange}
            onReset={this.onReset}
          /> */}
          <SetPermission
            permission="superAdmin"
            data={
              <Form>
                <div className="mb-3 d-flex flex-row-reverse">
                  <Form.Check
                    inline
                    label="IED Users"
                    onClick={() => this.Ieddata()}
                    name="group1"
                    type="radio"
                  />
                  <Form.Check
                    inline
                    label="Client Users"
                    onClick={() => this.clientdata()}
                    name="group1"
                    type="radio"
                  />
                  <Form.Check
                    inline
                    label="All Users"
                    defaultChecked
                    name="group1"
                    type="radio"
                    onClick={() => this.alldata()}
                  />
                </div>
              </Form>
            }
          ></SetPermission>

          <SetPermission
            permission={["superAdmin"]}
            data={
              <SelectAllHeader
                onSelectAll={this.handleOnSelectAll}
                onSort={this.onSortSelection}
                selectAllRef={this.selectAllRef}
                tableContainerRef={this.tableContainerRef}
              />
            }
          />
          {!this.state.loading ? (
            <SearchBootstrapTable
              searchKey={"userRegistrationDesktopSearch"}
              data={userData.map((d, idx) => ({ ...d, sid: idx + 1 }))}
              columns={sortableColumn}
              tableToolbarView={this.tableToolbarView}
              tableBeforeSearch={this.tableToolbarBeforeView}
              tableKey="userRegistration"
              defaultHideColumn={[
                "lastMobileEnableDate",
                "lastResentUserMailDate",
                "lastLogIn",
              ]}
              selectRow={
                isPermissions("superAdmin") || isPermissions("globalAdmin")
                  ? this.state.selectRow
                  : false
              }
              batchButtonView={this.sendMailButton}
            />
          ) : (
            <NetZeroLoader />
          )}
        </div>
        <LastLog subModulename={"users"} />
        <UserSiteModal
          title="Manage Permission"
          show={this.state.showSiteModal}
          setShow={this.handleCloseSiteModal}
          user={this.state.selectedUser}
          getAllList={this.setUserData}
        />
        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              <h1>{this.state.title}</h1>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h5 dangerouslySetInnerHTML={{ __html: this.state.description }} />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal size={"lg"} show={this.state.showViewModal} onHide={this.handleViewModal}>
          <Modal.Header>
            <Modal.Title>View Users</Modal.Title>
          </Modal.Header>

          <div className="col-lg-12">
            <div className="card mt-4 mb-3" style={{ overflow: "visible" }}>
              <div className="card-body">
                <div className="addressSmlSec" style={{ paddinTop: "0", borderTop: "0" }}>
                  <Row>
                    <Col md={3} className="drilingView-bx">
                      <h5>Current Location</h5>
                      <p>{modalData?.employee?.ehsSite?.name}</p>
                    </Col>
                    <Col md={3} className="drilingView-bx">
                      <h5>Location Type</h5>
                      <p>{modalData?.employee?.ehsSite?.siteType}</p>
                    </Col>
                    <Col md={3} className="drilingView-bx">
                      <h5>Emp ID</h5>
                      <p>{modalData?.employee?.employeeId}</p>
                    </Col>
                    <Col md={3} className="drilingView-bx">
                      <h5>Name</h5>
                      <p>
                        {capitalizeName(modalData?.firstName + " " + modalData?.lastName)}
                      </p>
                    </Col>
                    <Col md={3} className="drilingView-bx">
                      <h5>Email Id</h5>
                      <p>{modalData?.email}</p>
                    </Col>
                    <Col md={3} className="drilingView-bx">
                      <h5>Mobile Number</h5>
                      <p>
                        {modalData?.contactNumber || modalData?.employee?.mobileNumber}
                      </p>
                    </Col>
                    <Col md={3} className="drilingView-bx">
                      <h5>User Status</h5>
                      <p>{modalData?.userStatus}</p>
                    </Col>
                    <Col md={3} className="drilingView-bx">
                      <h5>Sign Up Date</h5>
                      <p>
                        {modalData?.createdAt ? DDMMYYYYFormat(modalData?.createdAt) : ""}
                      </p>
                    </Col>
                    <Col md={3} className="drilingView-bx">
                      <h5>Role</h5>
                      <p>{modalData?.role?.title}</p>
                    </Col>
                    <Col md={3} className="drilingView-bx">
                      <h5>Mail Sent Date</h5>
                      <p>
                        {modalData?.lastResentUserMailDate
                          ? DDMMYYYYHHMMAFormat(modalData?.lastResentUserMailDate)
                          : ""}
                      </p>
                    </Col>
                    <Col md={3} className="drilingView-bx">
                      <h5>Mobile Enabled Date</h5>
                      <p>
                        {modalData?.lastMobileEnableDate
                          ? DDMMYYYYHHMMAFormat(modalData?.lastMobileEnableDate)
                          : ""}
                      </p>
                    </Col>
                    <Col md={3} className="drilingView-bx">
                      <h5>Last Log In</h5>
                      <p>
                        {modalData?.lastLogIn
                          ? DDMMYYYYHHMMAFormat(modalData?.lastLogIn)
                          : ""}
                      </p>
                    </Col>
                    <Col md={3} className="drilingView-bx">
                      <h5>Access Permissions</h5>
                      <p>
                        {modalData?.accessPermissions?.map((d) => {
                          if (d.permissionValue === "1") {
                            return d.permission + ", ";
                          }
                        })}
                      </p>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseViewModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal size={"lg"} show={this.state.showEditModal} onHide={this.handleEditModal}>
          <Modal.Header>
            <Modal.Title>Edit User</Modal.Title>
          </Modal.Header>

          <AddUserRegistration
            id={this.state.rowUserId}
            modalHide={this.handleCloseEditModal}
            userPage={this.setUserData}
          />
        </Modal>

        <Modal size={"lg"} show={this.state.showAddModal} onHide={this.handleAddModal}>
          <Modal.Header>
            <Modal.Title>Add User</Modal.Title>
          </Modal.Header>

          <AddUserRegistration
            modalHide={this.handleCloseAddModal}
            userPage={this.setUserData}
          />
        </Modal>
      </div>
    );
  }
}

export default UserRegistration;
